import { apiClient } from './api'
import type { ApiResponse } from '@/types/api'
import type {
  Enrollment,
  EnrollmentFilters,
} from '@/types/enrollment'

export const enrollmentService = {
  enrollInCourse: async (
    courseId: string,
    batchId?: string,
    couponId?: string,
    discountAmount?: number
  ): Promise<ApiResponse<Enrollment>> => {
    const payload: Record<string, string | number> = { course_id: courseId }
    if (batchId) payload.batch_id = batchId
    if (couponId) payload.coupon_id = couponId
    if (discountAmount !== undefined) payload.discount_amount = discountAmount
    return apiClient.post('/enrollments', payload)
  },

  getEnrollment: async (id: string): Promise<ApiResponse<Enrollment>> => {
    return apiClient.get(`/enrollments/${id}`)
  },

  getUserEnrollments: async (
    userId: string,
    filters: EnrollmentFilters = {}
  ): Promise<ApiResponse<Enrollment[]>> => {
    return apiClient.get(`/enrollments/user/${userId}`, {
      params: filters,
    })
  },

  cancelEnrollment: async (id: string): Promise<ApiResponse<Enrollment>> => {
    return apiClient.delete(`/enrollments/${id}`)
  },

  getByCourse: async (courseId: string): Promise<ApiResponse<Enrollment[]>> => {
    return apiClient.get(`/enrollments/course/${courseId}`)
  },
}
